export interface OrgillEnvironment {
	production: boolean;
	environmentName: EnvironmentName;
	apiBaseUrl?: string;
}

export enum EnvironmentName {
	DEV = "DEV",
	QA = "QA",
	PROD = "PROD",
	LOCAL = "LOCAL",
}
